import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  Address_details,
  client_name,
  contact_number,
  Email_details,
  Email_detailsSecond,
  ImageUrl,
  media_details,
} from "../../../../../Helpers/request";
import {
  Facebook,
  Instagram,
  LinkedIn,
  Pinterest,
  Twitter,
} from "@material-ui/icons";
import { Link } from "@mui/material";

const FooterVenice = ({ currencydata }) => {
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [age, setAge] = React.useState("");
  const handleChangeAge = (event) => {
    setAge(event.target.value);
  };
  const [dropdown, setDropdown] = useState({
    img: localStorage.getItem("bw-currency_img"),
    icon: localStorage.getItem("bw-currencyicon"),
    code: localStorage.getItem("bw-currency"),
  });
  const currencyHandle = (code, img, icon) => {
    setDropdown({ img: img, icon: icon, code: code });
    localStorage.setItem("bw-currency", code);
    localStorage.setItem("bw-currency_img", img);
    localStorage.setItem("bw-currencyicon", icon);
    window.location.reload();
  };


  return (
    <>
      <footer id="footer">
        <div className="footer2 ftpd">
          <div className="container-fluid">
            <div className="main-footer2">
              <Row className="frowbg ">
                <Col lg={7} md={12} className="fbgimg">
                  <div className="lftfooter">
                    <div className="block-footer2 abtfooter">
                      <h2 className="title20 fw600  foot-w btfoot">About Us</h2>
                      <p className="foot-w">
                      drága kövek, meaning "precious stones" in Hungarian, was formed from our dream to bring you luxury at a fraction of the cost. Our prices are structured to bring you superior value, so you can happily begin the next chapter of your love story.
                        <NavLink className="foot_rmore foot-w" to="/our-story">
                          Read More
                        </NavLink>
                      </p>
                    </div>
                    <div className="block-footer2">
                      <h2 className="title20 fw600 foot-w btfoot">
                        Follow Us On
                      </h2>
                      <ul className="d-flex align-items-center">
                        {media_details.map((media, id) => (
                          media.account_link &&
                          <li key={id} className="mr-2">
                            <div className="rcs_footer_content_one_social_icn_div">
                              <a rel='noreferrer' href={media.account_link} target="_blank">
                                {media.account_icon}
                                <span className="d-none">
                                  {media.account_alt}
                                </span>
                              </a>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </Col>
                <Col lg={5} md={12} className="fgtext">
                  <div className="rightfooter dfl_footer_links">
                    <Row className="justify-content-center">
                      <Col lg={4} xs={12}>
                        <div className="block-footer2">
                          <h2 className="title20 dark">Get in Touch</h2>

                          <ul className="list-none contact-foter2">
                            <li>
                              <NavLink
                                to="#"
                                target="_blank"
                                onClick={() => {
                                  window.open(
                                    "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d27532.764999010633!2d-90.09402062590488!3d30.3908385588661!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sPO%20Box%20115%20%20Mandeville%2C%20LA%2070471!5e0!3m2!1sen!2sin!4v1740131354548!5m2!1sen!2sin",
                                    "_blank"
                                  );
                                }}
                              >
                                <i className="fa fa-map-marker dark" />
                                <span className="dark">
                                  {Address_details.textLine1}
                                  <br />
                                  {Address_details.textLine2}
                                </span>
                              </NavLink>
                            </li>
                          {contact_number.text && <li>
                            <i className="fa fa-volume-control-phone dark" />
                            <NavLink
                              to="#"
                              target="_blank"
                              onClick={(e) => {
                                window.location.href = contact_number.link;
                              }}
                            >
                              <span className="text-uppercase dark ">
                                {contact_number.text}
                              </span>
                            </NavLink>
                          </li>}
                            <li>
                              <i className="fa fa-envelope dark" />
                              <NavLink
                                className="dark"
                                to="#"
                                target="_blank"
                                onClick={(e) => {
                                  window.location.href = Email_details.link;
                                }}
                              >
                                {Email_details.text}
                              </NavLink>
                            </li>
                            {Email_detailsSecond.text && <li>
                              <NavLink
                                className="dark"
                                to="#"
                                target="_blank"
                                onClick={(e) => {
                                  window.location.href =
                                    Email_detailsSecond.link;
                                }}
                              >
                                {Email_detailsSecond.text}
                              </NavLink>
                            </li>}
                          </ul>
                        </div>
                      </Col>
                      <Col lg={4} xs={12}>
                        <div className="block-footer3">
                          <h2 className="title20 dark ">
                            Help &amp; Information
                          </h2>
                          <ul className="list-none contact-foter2">
                            {/* <li><NavLink to="https://marblecaves.demobw.com/contact" className="dark ">Contact Us</NavLink></li> */}
                            <li>
                              <NavLink to="/return-policy" className="dark">
                              Return policy
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/privacy-policy" className="dark ">
                                Privacy Policy
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                to="/terms-and-conditions"
                                className="dark"
                              >
                                Terms &amp; Conditions
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </Col>
                      <Col lg={4} xs={12}>
                        <div className="block-footer3">
                          <h2 className="title20 dark">Info</h2>
                          <ul className="list-none contact-foter2">
                            <li>
                              <NavLink to="/our-story" className="dark">
                                About Us
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/contact" className="dark ">
                                Contact Us
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/education" className="dark ">
                                Education
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div className="bottom-bar">
          <p className="desc copyright-footer text-center mb-1">
            Copyright © {new Date().getFullYear()} {client_name.c_name} All
            Rights Reserved. | Designed & Developed by Belgium WebNet
          </p>
        </div>
      </footer>

      {/* Whatsapp Chat */}
      {/* <NavLink to="https://wa.me/+16469929024" className="whatsapp_float" target="_blank" rel="noopener noreferrer">
      <Image src={whatsapp} alt="whatspp chat"></Image>
    </NavLink> */}
      {/* Whatsapp Chat */}
      {/* <div className='rcs_footer_chat'>
      <div className='rcs_diamond_specialist'>

      </div>
      <div className='rcs_diamond_tdo_chat'>

      </div>
    </div> */}

      {/* <div className="newsletter-toolbar d-none d-xl-block d-lg-block">
        <div className="toolbar--social">
          <div className="icon-social">
            <ul className="social-icons">
              <li className="facebook">
                <NavLink
                  to="#"
                  title="Facebook"
                  target="_blank"
                  onClick={() => {
                    window.open("/", "_blank");
                  }}
                >
                 
                  <Facebook />
                </NavLink>
              </li>
              <li className="twitter">
                <NavLink
                  to="#"
                  title="Twitter"
                  target="_blank"
                  onClick={() => {
                    window.open("/", "_blank");
                  }}
                >
                  
                  <Twitter />
                </NavLink>
              </li>
              <li className="instagram">
                <NavLink
                  to="#"
                  title="Instagram"
                  target="_blank"
                  onClick={() => {
                    window.open("/n", "_blank");
                  }}
                >
                  
                  <Instagram />
                </NavLink>
              </li>
              <li className="whatsapp">
                <NavLink
                  to="#"
                  target="_blank"
                  className="inline-block round"
                  onClick={() => {
                    window.open("/", "_blank");
                  }}
                >
                 
                  <Pinterest />
                </NavLink>
              </li>
              <li className="whatsapp">
              <NavLink className="" to="#" target="_blank" onClick={() => { window.open('https://www.yelp.ca/biz/diamonds-for-less-toronto', '_blank') }} title="yelp" >
                <i className="fa fa-yelp fa-lg" aria-hidden="true"></i>
              </NavLink>
            </li>
              <li className="whatsapp">
              <NavLink to="/" title="whatsapp" target="_blank">
                <i className="fa fa-whatsapp fa-lg" aria-hidden="true" />
              </NavLink>
            </li>
              <li className="linkedin">
                <NavLink
                  className="disabled-link"
                  to="/"
                  title="linkedin"
                  target="_blank"
                >
                  
                  <LinkedIn />
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
        <div className="toolbar--text">
          <span data-modal-newsletter className="newsletter-toolbar_popup">
            Newsletter
          </span>
        </div>
      </div> */}

      {/* <div className="dfl_wholesale">
        <LazyLoadImage
          src={`${ImageUrl}theme/venice/Wholesale.webp`}
          alt="whole sale"
        />
      </div> */}
    </>
  );
};
export default FooterVenice;
